import { addEvent, triggerEvent } from '../../../../utils/events';
import { btnCancelEvent, btnConfirmEvent, inputFocusEvent, inputFocusOutEvent, inputEvent } from '../events/index';
import addClasses from '../../../../utils/addClasses';
import createAnchorElement from './createAnchorElement';
import removeInputElement from '../removeElements/removeInputElement';

/* CREATES INPUT ELEMENT FOR INLINE EDITING */

export default function createInlineEditElement(element, linkConfig) {
  let initialValue = element;

  // Create span to wrap input element
  const span = document.createElement('span');

  // Create input element
  const input = document.createElement('input');
  input.type = 'text';
  input.name = element;
  input.value = element;
  input.autocomplete = 'off';

  if (linkConfig && linkConfig.classList.contains('required')) {
    input.classList.add('required');
  }

  const magicBreakpoint = 768;
  addEvent(window, 'resize', () => {
    if (window.innerWidth < magicBreakpoint) {
      input.disabled = true;
    } else {
      input.disabled = false;
    }
  });

  // Create icon elements
  const iconWrapper = document.createElement('div');
  iconWrapper.classList.add('icon__wrapper');
  const iconPencil = document.createElement('i');
  iconPencil.classList.add('icon-cme-pencil');
  iconWrapper.appendChild(iconPencil);

  // Create actions element
  const actions = document.createElement('div');
  addClasses(actions, [
    'actions',
    'display--none',
  ]);

  // Create cancel button element
  const btnCancel = document.createElement('button');
  btnCancel.classList.add('btn', 'btn--secondary', 'btn--cancel');
  const iconRemove = document.createElement('i');
  addClasses(iconRemove, [
    'fa',
    'fa-remove',
  ]);
  btnCancel.appendChild(iconRemove);

  // Create confirm button element
  const btnConfirm = document.createElement('button');
  addClasses(btnConfirm, [
    'btn',
    'btn--positive',
    'btn--confirm',
  ]);
  const iconCheck = document.createElement('i');
  addClasses(iconCheck, [
    'fa',
    'fa-check',
  ]);
  btnConfirm.appendChild(iconCheck);

  // Append buttons to actions container
  actions.appendChild(btnCancel);
  actions.appendChild(btnConfirm);

  // Append elements to span wrapper
  span.appendChild(input);
  span.appendChild(iconWrapper);
  span.appendChild(actions);

  let anchor = {};
  let anchorInput = {};
  // Add mousedown event listener for cancel button
  addEvent(btnCancel, 'mousedown', (event) => {
    if (linkConfig) {
      anchorInput = removeInputElement(span);

      linkConfig.linkText = initialValue;
      linkConfig.icons.icon.classList.remove('display--none');
      linkConfig.icons.iconDisabled.classList.add('display--none');

      anchor = createAnchorElement(linkConfig);
      anchorInput.parent.appendChild(anchor);
    } else {
      btnCancelEvent(input, initialValue, actions, event, btnConfirm);
    }
  });

  // Add mousedown event listener for confirm button
  addEvent(btnConfirm, 'mousedown', (event) => {
    if (linkConfig) {
      if (input.value !== '' || !input.classList.contains('has-error')) {
        const table = input.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
        anchorInput = removeInputElement(span);

        linkConfig.linkText = anchorInput.inputValue;
        linkConfig.icons.icon.classList.remove('display--none');
        linkConfig.icons.iconDisabled.classList.add('display--none');

        anchor = createAnchorElement(linkConfig);
        anchorInput.parent.appendChild(anchor);
        triggerEvent(table, 'apply.commonui.inline-edit');
      }
      btnConfirmEvent(input, actions, event, btnConfirm);
    } else {
      if (input.value !== '' || !input.classList.contains('has-error')) {
        initialValue = input.value;
      }
      const table = input.parentElement.parentElement.parentElement.parentElement.parentElement;
      btnConfirmEvent(input, actions, event, btnConfirm);
      triggerEvent(table, 'apply.commonui.inline-edit');
    }
  });

  // Add focusin event listener for input
  addEvent(input, 'focusin', () => {
    inputFocusEvent(actions);
  });

  // Add onclick event listener for input
  addEvent(input, 'click', () => {
    input.select();
  });

  // Add focusout event listener for input
  addEvent(input, 'focusout', (event) => {
    if (linkConfig) {
      event.preventDefault();
    } else if (input.classList.contains('invalid')) {
      event.preventDefault();

      input.classList.remove('invalid');
      input.focus();
    } else {
      inputFocusOutEvent(input, actions, event, btnConfirm);
      input.value = initialValue;
    }
  });

  // Add oninput event listener for input
  addEvent(input, 'input', () => {
    inputEvent(input, btnConfirm);
  });

  return span;
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/createElements/createInlineElement.js